import './App.scss'
import { Toaster } from 'react-hot-toast'

import AppProvider from './context/AppContext'
import AppLayout from './views/templates/AppLayout'
import './styles/fonts/MontserratAlternates/stylesheet.css'
import './styles/fonts/MabryPro/stylesheet.css'
import 'assets/splash.png'

const App = () => {
  return (
    <div className="App__container">
      <AppProvider>
        <Toaster />
        <AppLayout />
      </AppProvider>
    </div>
  )
}

export default App
